import React from 'react';

const VideoSlide = () => (
  <section className="py-5 px-4" style={{ backgroundColor: '#e6f0f5' }}>
    <div className="container">
      <div className="row align-items-center g-5">
        {/* Left Text Column */}
        <div className="col-lg-5">
          <h2 className="mb-3">See Nurturix in Action</h2>
          <br/>
          <h4 className="mb-3">Lead Management</h4>
          <p className="mb-0 fs-5">
            Check the video learn more about,how we can help generate leads and how easy it is to manage your leads.
          </p>
          <br/>
          <p className="mb-0 fs-5">
            You can change the state of your leads or it can be done automatically for you when there is an event.Check the video for more details.
          </p>
        </div>

        {/* Right Video Column */}
        <div className="col-lg-7 text-center text-lg-end">
          <video
            src='/assets/videos/prospectpulsedemo.mov'
            controls
            className="rounded shadow-sm w-100"
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  </section>
);

export default VideoSlide;
